import React from 'react';

import './Spinner.scss';

function Spinner() {
  return (
    <div className="spinner">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}

export default Spinner;
